module.exports = __webpack_public_path__ + "static/why-time.2069c639.jpg";